module.exports = __webpack_public_path__ + "static/img/fz_rb_what.3481d3a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/fz_rb_what.png
// module id = Tkp4
// module chunks = 0